export default "__VITE_ASSET__1e7a5354__"